<template>
  <el-dialog
    :title="rateCard.name"
    visible
    top="5vh"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="$emit('update:isShow', false)"
  >
    <h1>
      PDF Export<br>
      <small>
        Export a Rate Card into a commonly shareable format
      </small>
    </h1>

    <el-form
      ref="exportForm"
      v-loading="isSaving"
      :rules="rules"
      :model="formModel"
      size="small"
    >
      <el-form-item
        label="Template"
        prop="template"
      >
        <el-select
          v-model="formModel.template"
          placeholder="Select a Template"
          class="w-100"
        >
          <el-option
            label="Default"
            :value="'default'"
          />
          <el-option
            label="Breaks"
            :value="'breaks'"
          />
          <el-option
            label="Items"
            :value="'items'"
          />
        </el-select>
      </el-form-item>

      <template v-if="formModel.template === 'items'">
        <el-form-item
          label="Show Services"
          prop="show_services"
        >
          <el-select
            v-model="formModel.show_services"
            multiple
            filterable
            placeholder="All Services"
            :loading="isLoadingServices"
            class="w-100"
          >
            <el-option
              v-for="service in services"
              :key="service.id"
              :label="service.name"
              :value="service.id"
            />
          </el-select>
        </el-form-item>

        <el-form-item>
          <template #label>
            Optional Data
          </template>

          <br>

          <el-checkbox v-model="formModel.shipping_code">
            Shipping Code
          </el-checkbox>

          <el-checkbox v-model="formModel.minimum">
            Minimum
          </el-checkbox>

          <el-checkbox v-model="formModel.weight_limit">
            Weight Limit
          </el-checkbox>
        </el-form-item>
      </template>

      <el-form-item
        label="Zone From"
        prop="zone"
      >
        <el-select
          v-model="formModel.zone"
          filterable
          placeholder="Select a zone"
          :loading="isLoadingZones"
          class="w-100"
        >
          <el-option
            v-for="zone in zones"
            :key="zone.id"
            :label="zone.zone.desc"
            :value="zone.zone.id"
          />
        </el-select>
      </el-form-item>

      <el-form-item
        label="Account"
        prop="account"
      >
        <el-select
          v-model="formModel.account"
          filterable
          placeholder="Select an Account"
          :loading="isLoadingAccounts"
          class="w-100"
        >
          <el-option
            v-for="account in accounts"
            :key="account.id"
            :label="account.name"
            :value="account.id"
          />
        </el-select>
      </el-form-item>

      <el-form-item
        label="Signed By"
        prop="signedBy"
      >
        <el-input
          v-model="formModel.signedBy"
          placeholder="Signed By"
          clearable
        />
      </el-form-item>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click.native="$emit('update:isShow', false)">
        Cancel
      </el-button>

      <el-button
        type="primary"
        :loading="isSaving"
        @click.native="exportPDF"
      >
        Export
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    rateCard: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isFullscreen: false,
      isSaving: false,
      zones: [],
      isLoadingZones: false,
      accounts: [],
      isLoadingAccounts: false,
      services: [],
      isLoadingServices: false,
      formModel: {
        template: 'default',
        shipping_code: false,
        minimum: false,
        weight_limit: false,
        show_services: [],
        zone: null,
        account: null,
        signedBy: ''
      },
      rules: {
        signedBy: [
          { required: true, message: 'Signed By is required', trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  created () {
    this.loadLists()
  },
  methods: {
    loadLists () {
      // Zones
      this.isLoadingZones = true
      this.$sdk.locationcarrierzone.list(builder => {
        builder.context = { resource: 'pivot' }
        builder.include = ['zone']
        builder.limit = 1000
        builder.filters = { pivot_location_carrier_zone_carrier: this.rateCard.carrier.id, pivot_location_carrier_zone_grouped: true }
      })
        .then(res => { this.zones = res })
        .finally(() => { this.isLoadingZones = false })
      // Accounts
      this.isLoadingAccounts = true
      this.$sdk.account.list(builder => {
        builder.filters = { account_active: 1, rate_card_strict_uuid: this.rateCard.id }
      })
        .then(res => { this.accounts = res })
        .finally(() => { this.isLoadingAccounts = false })
      // Services
      this.isLoadingServices = true
      this.$sdk.carrier_service.list(builder => {
        builder.context = { resource: 'carrier', id: this.rateCard.carrier.id }
      }).then(res => { this.services = res })
        .finally(() => { this.isLoadingServices = false })
    },
    exportPDF () {
      this.$refs.exportForm.validate((valid) => {
        if (valid) {
          this.isSaving = true
          const job = new this.$sdk.job()
          job.name = 'export.pdf.ratecard'
          job.parameters = {
            rate_card: this.rateCard.id,
            template: this.formModel.template,
            account: this.formModel.account,
            signed_by: this.formModel.signedBy,
            zone_from: this.formModel.zone,
            shipping_code: this.formModel.shipping_code,
            minimum: this.formModel.minimum,
            weight_limit: this.formModel.weight_limit,
            show_services: this.formModel.show_services
          }
          job.create()
            .then(() => this.$message({ message: 'Job has been added to the queue', type: 'success' }))
            .finally(() => {
              this.isSaving = false
              this.$emit('update:isShow', false)
            })
        }
      })
    }
  }
}
</script>

<style>

</style>
